export var FedopsInteractions;
(function (FedopsInteractions) {
    FedopsInteractions["AddToCart"] = "add-to-cart";
    FedopsInteractions["AddToWishlist"] = "add-to-wishlist";
    FedopsInteractions["ApplyCouponInOrder"] = "apply-coupon-interaction";
    FedopsInteractions["BuyNow"] = "buy-now";
    FedopsInteractions["RemoveFromWishlist"] = "remove-from-wishlist";
    FedopsInteractions["RemoveItemFromCart"] = "remove-item-interaction";
    FedopsInteractions["Subscribe"] = "subscribe";
    FedopsInteractions["NotifyMe"] = "notify-me";
    FedopsInteractions["UpdateQuantityInCart"] = "update-quantity-interaction";
    FedopsInteractions["ViewCheckoutInteraction"] = "view-checkout";
    FedopsInteractions["WixCodeGetCustomTextFieldValues"] = "wixcode-get-custom-text-field-values";
    FedopsInteractions["WixCodeGetCustomTextFieldValuesSSR"] = "wixcode-get-custom-text-field-values-ssr";
    FedopsInteractions["WixCodeGetProduct"] = "wixcode-get-product";
    FedopsInteractions["WixCodeGetProductSSR"] = "wixcode-get-product-ssr";
})(FedopsInteractions || (FedopsInteractions = {}));
//# sourceMappingURL=fedopsInteractions.js.map